import { useAppStore } from './store.js';

/**
 * Vier per Web Audio synthetisierte Signaltöne — keine Audio-Dateien nötig.
 * Standardmäßig aus (GDD Mobile-Härtung); der AudioContext wird erst beim
 * ersten Nutzer-Tap entsperrt, wie es die meisten Browser verlangen.
 */
let ctx: AudioContext | null = null;

function getContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  if (!ctx) ctx = new Ctor();
  if (ctx.state === 'suspended') void ctx.resume();
  return ctx;
}

export function unlockAudio(): void {
  if (!useAppStore.getState().soundEnabled) return;
  getContext();
}

function tone(freq: number, durationMs: number, delayMs = 0, gainValue = 0.08): void {
  if (!useAppStore.getState().soundEnabled) return;
  const audio = getContext();
  if (!audio) return;

  const start = audio.currentTime + delayMs / 1000;
  const oscillator = audio.createOscillator();
  const gain = audio.createGain();
  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(freq, start);
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(gainValue, start + 0.01);
  gain.gain.linearRampToValueAtTime(0, start + durationMs / 1000);

  oscillator.connect(gain);
  gain.connect(audio.destination);
  oscillator.start(start);
  oscillator.stop(start + durationMs / 1000 + 0.02);
}

export const sound = {
  tick: () => tone(880, 60),
  phaseChange: () => {
    tone(523, 90);
    tone(659, 110, 90);
  },
  voteCast: () => tone(740, 80),
  eliminated: () => {
    tone(392, 140);
    tone(330, 220, 130);
  },
  gameOver: () => {
    tone(523, 120);
    tone(659, 120, 110);
    tone(784, 220, 220);
  },
};
